import Utils from '../../services/Utils'
import { FormErrorStrategy } from '../config/ErrorHandler'
import { GApi, defineCancelApiObject, defaultHeaders } from '../config/GApi'

const ReportGroupsApi = {
  get: async function (reportId, cancel = false) {
    const response = await GApi.request({
      url: '/global-reporting/report-groups/' + reportId,
      method: 'GET',
      headers: defaultHeaders(),
      errorStrategy: FormErrorStrategy,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
}

const cancelApiObject = defineCancelApiObject(ReportGroupsApi)
export default ReportGroupsApi
